import { Injectable } from '@angular/core';
import { Sucursal } from 'src/app/core/models/sucursal/sucursal';

@Injectable({
	providedIn: 'root'
})
export class SharedDataFormService {
	data: any = {};
	companyBranches: any[] = [];
	setBranchData(component: any): boolean {
		if (
			component.data.addedBranches.includes(
				Number(component.formGroup.controls['numeroRUCA'].value)
			) &&
			!component.data.isEdit
		) {
			return false;
		} else {
			const branchTypeIndex = component.branchTypes.findIndex(
				(type: any) =>
					type.key == component.formGroup.controls['tipoSucursal'].value
			);
			const city = component.formGroup.controls['localidad'].value;
			const provinceIndex = component.provinces.findIndex(
				(type: any) =>
					type.key == component.formGroup.controls['provincia'].value
			);
			const branch: Sucursal = {
				descripcion: component.formGroup.controls['sucursal'].value,
				tipoSucursal: {
					id: component.formGroup.controls['tipoSucursal'].value,
					descripcion: component.branchTypes[branchTypeIndex].value
				},
				propia: component.formGroup.controls['sucursalPropia'].value,
				localidad: {
					id: city.key,
					nombre: city.value,
					provincia: {
						id: component.formGroup.controls['provincia'].value,
						nombre: component.provinces[provinceIndex].value
					}
				},
				direccion: component.formGroup.controls['direccion'].value,
				numeroRUCA: component.formGroup.controls['numeroRUCA'].value,
				numeroLOT: component.formGroup.controls['numeroLOT'].value,
				sucursalEmpresasCertificadoras: []
			};
			if (component.formGroup.controls['sucursalPropia'].value == 'terceros') {
				const sucursalTerceros =
					component.formGroup.controls['sucursalTerceros'].value;
				branch.id = sucursalTerceros.key;
			}
			this.data.addedBranch = branch;
			return true;
		}
	}
}
